module.exports = __webpack_public_path__ + "dist/img/eecu-logo.65952f74.png";